import React from 'react';

function SvgWrap({ children, className }) {
  return (
    <span className={`inline-flex shrink-0 text-b2b-orange ${className || ''}`}>
      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.6} aria-hidden>
        {children}
      </svg>
    </span>
  );
}

export function CategoryRowIcon({ name = '' }) {
  const n = (name || '').toLowerCase();
  if (/apparel|cloth|textile|fashion|wear/.test(n)) {
    return (
      <SvgWrap>
        <path strokeLinecap="round" strokeLinejoin="round" d="M16 7V4a2 2 0 00-2-2h-1a2 2 0 00-2 2v3M8 7V4a2 2 0 012-2h1a2 2 0 012 2v3M4 7h16l-1 14H5L4 7z" />
      </SvgWrap>
    );
  }
  if (/electron|consumer|phone|computer|tech|audio/.test(n)) {
    return (
      <SvgWrap>
        <rect x="7" y="4" width="10" height="14" rx="2" fill="none" />
        <path strokeLinecap="round" d="M11 18h2" />
      </SvgWrap>
    );
  }
  if (/sport|fitness|entertain/.test(n)) {
    return (
      <SvgWrap>
        <circle cx="12" cy="12" r="8" />
        <path strokeLinecap="round" d="M12 8v8M8 12h8" />
      </SvgWrap>
    );
  }
  if (/beauty|cosmetic|personal|health/.test(n)) {
    return (
      <SvgWrap>
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 3h6v2a3 3 0 01-6 0V3zM7 8h10v11a2 2 0 01-2 2H9a2 2 0 01-2-2V8z" />
      </SvgWrap>
    );
  }
  if (/home|garden|furniture|packag/.test(n)) {
    return (
      <SvgWrap>
        <path strokeLinecap="round" strokeLinejoin="round" d="M4 10l8-6 8 6M6 10v10h12V10" />
      </SvgWrap>
    );
  }
  if (/machine|industrial|tool|metal|build|cement|mater/.test(n)) {
    return (
      <SvgWrap>
        <path strokeLinecap="round" strokeLinejoin="round" d="M14 10l-2 2m0 0l-2-2m2 2v6m6-10h-3l-1-3H8L7 10H4v10h16V10h-3z" />
      </SvgWrap>
    );
  }
  return (
    <SvgWrap>
      <path strokeLinecap="round" strokeLinejoin="round" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
    </SvgWrap>
  );
}
